import { Link } from 'react-router-dom';
import { Logo, Wordmark } from '../brand/Logo';

const footerLinks = {
  tools: [
    { name: 'JSON Formatter', href: '/json-formatter' },
    { name: 'JWT Decoder', href: '/jwt-decoder' },
    { name: 'Base64 Encoder', href: '/base64' },
    { name: 'Regex Tester', href: '/regex-tester' },
    { name: 'All Tools', href: '/tools' },
  ],
};

export default function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-surface/30">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="md:col-span-2 max-w-sm">
            <Link to="/tools" className="flex items-center gap-2 mb-4">
              <Logo size={32} />
              <Wordmark />
            </Link>
            <p className="text-slate-400 text-sm">
              Fast, private, and free developer tools. All tools run directly in your browser.
            </p>
          </div>

          {/* Tools */}
          <div>
            <h3 className="font-semibold text-white mb-4">Tools</h3>
            <ul className="space-y-2">
              {footerLinks.tools.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-slate-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-sm text-slate-500 text-center sm:text-left">
            © {new Date().getFullYear()} DevKit. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
